import graphql__3c6869ef909408485a79 from "./__generated__/ContributionDetailsModalManagerQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../../AppQueryRenderer";

import ContributionDetailsModal from "./ContributionDetailsModal";
import { useResourcesList } from "../../ResourcesList/resourcesList";
import ModalLoader from "../../Modals/ModalLoader";
import ModalErrorBoundary from "../../ErrorBoundaries/ModalErrorBoundary";

const ContributionDetailsModalManager = props => {
  const resourcesList = useResourcesList();
  const contributionId = resourcesList?.selection?.itemId;

  // No contribution selected, we don't need to show anything
  if (!contributionId) return null;

  return (
    <AppQueryRenderer
      query={ContributionDetailsModalManagerQuery}
      variables={{ contributionId, commentsCount: 2147483647 }}
      additionalProps={props}
      component={ContributionDetailsModal}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
    />
  );
};

const ContributionDetailsModalManagerQuery = graphql__3c6869ef909408485a79;

export default ContributionDetailsModalManager;
